/**
 * Chart colours - "Signature Blue + Graphite + Mineral White + Muted Teal".
 * Board of Directors and Head of Marketing, "Sample UI screens OVAL IMS"
 * (applied 10-10-2026). Replaces the Emerald palette of 30-09-2026.
 *
 * Charts are drawn by recharts, which takes colours as hex strings rather than
 * Tailwind class names, so they cannot follow tailwind.config.js on their own.
 * This file is their half of the palette, and matches tailwind.config.js.
 *
 * The document's most important rule for charts: DON'T MAKE EVERY CHART OVAL
 * BLUE. Colour carries meaning, so a dashboard reads without its labels:
 *
 *   value / the main series   OVAL Blue   #3C55A5
 *   available / healthy       Muted teal  #0F766E
 *   reserved / neutral        Slate       #71807C
 *   low / needs attention     Bronze      #806A45
 *   out / genuinely bad       Muted red   #C2414A
 */

export const BRAND = '#3C55A5'        // OVAL Blue - the main series
export const BRAND_DARK = '#293B78'   // pressed
export const BRAND_LIGHT = '#9AA8D5'  // a lighter series next to BRAND
export const TEAL = '#0F766E'         // healthy / available / complete
export const GRAPHITE = '#4B5A56'     // a second series that is not "brand"
export const NEUTRAL = '#71807C'      // reserved, idle, not yet due
export const ATTENTION = '#806A45'    // low, ageing, needs review
export const DANGER = '#C2414A'       // genuinely bad - overdue beyond 90 days, short stock
export const SUCCESS = '#15803D'

/** Axis labels, grid lines and hover washes. */
export const AXIS_TEXT = '#71807C'
export const AXIS_TEXT_STRONG = '#33423E'
export const GRID = '#DFE6E3'
export const HOVER_WASH = '#F1F4F3'

/**
 * Eight categories, in order: OVAL Blue first, then teal, then the neutrals,
 * with the soft steps last - distinguishable side by side, never a rainbow, and
 * no colour that means "attention" or "error" used as a mere category.
 */
export const CHART_SERIES = [
  '#3C55A5', '#0F766E', '#71807C', '#9AA8D5', '#7CC6BA',
  '#4B5A56', '#293B78', '#C9D4D0',
]

/**
 * A "fresh to stale" or "on time to overdue" ladder: teal for good, slate for
 * the early middle, bronze as it ages, and the muted red only at the end.
 */
export const LADDER = ['#0F766E', '#71807C', '#806A45', '#6B583A', DANGER]
